import { getConfig } from '../lib/config';
import { setBoundingBox } from '../lib/utils';
import { stateInfoRequest } from '../lib/request';

const REVERSE_GEOCODE_PATH = '/reverseGeocode';

export const reverseGeocode = (location) => {
  let path = getConfig('REVERSE_GEOCODE_SERVICE');

  if (path && !path.endsWith(REVERSE_GEOCODE_PATH)) {
    path += REVERSE_GEOCODE_PATH;
  }

  const params = {
    f: 'json',
    location,
  }

  return stateInfoRequest('get', path , params);
};

export const stateInfo = (point, radius) => {
  const baseUrl = getConfig('BASE_SERVICES_URL');
  const path = `${baseUrl}/basemap/County/MapServer/0/query`

  const boundingBox = setBoundingBox(point, radius)
  const params = {
    f: 'json',
    geometry: { ...boundingBox, spatialReference: { wkid: 102100 } },
    geometryType: 'esriGeometryEnvelope',
    outFields: '*',
    returnGeometry: 'false',
    spatialRel: 'esriSpatialRelIntersects',
  }

  return stateInfoRequest('get', path , params);
};

// New hunt unit service - Queries the GMU hunt_units_query MapServer for a state with a bounding box around the clicked point.
// URL pattern example: .../services/colorado/COLORADO_GMU_hunt_units_query/MapServer/0/query
export const huntUnitQuery = (stateName, point, radius = 1) => {
  const baseUrl = getConfig('BASE_SERVICES_URL');
  const stateFolder = stateName.toLowerCase().replace(/\s+/g, '-');
  const stateUpper = stateName.toUpperCase().replace(/\s+/g, '_');
  const path = `${baseUrl}/${stateFolder}/${stateUpper}_GMU_hunt_units_query/MapServer/0/query`;
  const boundingBox = setBoundingBox(point, radius);
  const params = {
    f: 'json',
    geometry: { ...boundingBox, spatialReference: { wkid: 102100 } },
    geometryType: 'esriGeometryEnvelope',
    inSR: 102100,
    outFields: '*',
    returnGeometry: 'false',
    spatialRel: 'esriSpatialRelIntersects',
  };
  return stateInfoRequest('get', path, params);
};
